module.exports = __webpack_public_path__ + "img/factura.87174bc9.png";